import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPixel, verifyPixelInstalled, isPixelDebug } from "@/lib/pixel";

/**
 * Mount inside <BrowserRouter>. Verifies Pixel install once and fires
 * route-specific events on /rooms and /enquire so debug mode can confirm
 * the pixel is firing correctly on those pages.
 */
const PixelTracker = () => {
  const location = useLocation();

  useEffect(() => {
    verifyPixelInstalled();
    if (isPixelDebug()) {
      // eslint-disable-next-line no-console
      console.info(
        "%c[FB Pixel] debug mode ON",
        "color:#1877F2;font-weight:bold;",
        "Watch the Network tab for requests to facebook.com/tr",
      );
    }
  }, []);

  useEffect(() => {
    const path = location.pathname;

    // Google Analytics 4 page_view
    if (typeof window !== "undefined" && typeof (window as unknown as { gtag?: (...args: unknown[]) => void }).gtag === "function") {
      (window as unknown as { gtag: (...args: unknown[]) => void }).gtag("event", "page_view", {
        page_path: path + location.search,
        page_location: window.location.href,
        page_title: document.title,
      });
    }

    if (path === "/rooms" || path.startsWith("/rooms/")) {
      trackPixel("ViewContent", {
        content_category: "Rooms & Suites",
        content_name: path,
        content_type: "product_group",
      });
    } else if (path === "/enquire") {
      trackPixel("ViewContent", {
        content_category: "Enquiry",
        content_name: "Enquiry Form",
      });
      trackPixel("Lead", {
        content_category: "Enquiry",
        content_name: "Enquiry Page Visit",
      });
    }
  }, [location.pathname, location.search]);

  return null;
};

export default PixelTracker;
